jQuery(document).on('click','.js-toggle-menu', function(e) {
    e.preventDefault();
    jQuery(this).toggleClass('is-open');
    jQuery('.js-mobile-overlay').fadeToggle();
    jQuery(this).siblings('.primary-menu__wrapper').toggleClass('is-open');
}); 
